import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, mergeMap, switchMap} from 'rxjs/operators';
import {from, of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {
	EActivityActions,
	GetActivities,
	GetActivitiesSuccess,
	GetActivity,
	GetActivitySuccess,
	GetRelationActivity,
	GetRelationActivitySuccess
} from '@app/core/store/actions/activity.actions';
import {ActivityService} from '@app/core/services/api/activity.service';

@Injectable()
export class ActivityEffects {

	@Effect()
	public onGetActivities$ = this.actions$.pipe(
		ofType<GetActivities>(EActivityActions.GetActivities),
		switchMap((action: GetActivities) => from(this.activityService.getActivities(action.departmentId, action.subjectType, action.subjectId)).pipe(
			switchMap((activities) => [
				new GetActivitiesSuccess(activities.data, activities.pagination),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onGetActivity$ = this.actions$.pipe(
		ofType<GetActivity>(EActivityActions.GetActivity),
		mergeMap((action: GetActivity) => from(this.activityService.getActivity(action.departmentId, action.activityId)).pipe(
			mergeMap((activity) => [
				new GetActivitySuccess(activity),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);
	@Effect()
	public onGetRelationActivity$ = this.actions$.pipe(
		ofType<GetRelationActivity>(EActivityActions.GetRelationActivity),
		mergeMap((action: GetRelationActivity) => from(this.activityService.getRelationActivity(action.departmentId, action.model, action.model_id, action.relation)).pipe(
			mergeMap((activities) => [
				new GetRelationActivitySuccess(activities.data, activities.pagination),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	constructor(
		private actions$: Actions,
		private activityService: ActivityService
	) {
	}
}
